<template>
    <div></div>
</template>
<script>
import { debounce } from 'lodash';
import { createWidgetMixin } from 'vue-instantsearch';
import { connectCurrentRefinements } from 'instantsearch.js/es/connectors'

export default {
    mixins: [
        createWidgetMixin({ connector: connectCurrentRefinements })
    ],

    watch: {
        'state.items': function (newVal, oldVal) {
            if (!oldVal || !newVal) return;
            if (newVal.length > oldVal.length) this.debouncedWatcher();
        }
    },

    computed: {
        widgetParams() {
            return {
                excludedAttributes: [],
            };
        },
    },

    created() {
        this.debouncedWatcher = debounce(this.emitChange, 1000);
    },

    methods: {
        emitChange() {
            this.$emit('change');
        }
    }
}
</script>
